<template>
  <el-card>
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
           <span class="toggle-zero-label">Afficher total caisses = 0</span>
           <el-switch
             v-model="showZeroTotalCases"
             @click.native="handleToggleZeroTotalCases"
             @change="handleZeroTotalCasesChange"
           ></el-switch>
           <span class="toggle-zero-label">Afficher variance</span>
           <el-switch
             v-model="showVariance"
           ></el-switch>
           <el-dropdown size="small" type="default" class="">
             <el-button type="primary" size="small">
               <i class="el-icon-download"></i>
             </el-button>
             <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="downloadExcel"><i class="mdi mdi-file-excel"/> Excel</el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown>
           <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
  			</div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>

      </p>
      <div id="printMe">
        <el-row>
          
          <el-table :data="filteredTableData" :style="tableWidth" stripe border empty-text="Il n'y a aucune vente pour cette période" class="fs-10">
            <el-table-column label="Produit" min-width="220" fixed>
              <template slot-scope="scope">
                <div class="product-name">{{ scope.row.product_name }}<span v-if="scope.row.provider_name"> - {{scope.row.provider_name}}</span></div>
                <div class="product-sku">{{ scope.row.sku }}</div>
                <div class="product-meta">{{ scope.row.uvc || '-' }} | {{ scope.row.volume || '-' }} ml</div>
              </template>
            </el-table-column>
            <el-table-column
              v-for="col in monthColumns"
              :key="col.prop"
              :label="col.label"
              align="center"
              width="70"
            >
              <template slot-scope="scope">
                <div class="month-value-cell">
                  <div class="month-value">{{ formatMonthValue(scope.row, null, scope.row[col.prop]) }}</div>
                  <div v-if="showVariance" :class="['variance', getMonthVarianceClass(scope.row, col.monthIndex)]">
                    {{ getMonthVarianceText(scope.row, col.monthIndex) }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Total caisses"
              align="center"
              width="120"
              sortable
              :sort-method="sortByTotalCases"
              fixed
            >
              <template slot-scope="scope">
                <div class="total-cases-cell">
                  <div class="total-value">{{ getTotalCases(scope.row) }}</div>
                  <div v-if="showVariance" :class="['variance', getVarianceClass(scope.row)]">
                    {{ getVarianceText(scope.row) }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          
        </el-row>
      </div>
    <reportFilter v-if="!loading"
                  :showPeriodSelector="false"
                  :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  :customerFilter="true"
                  :customer="selectedCustomer"
                  :providerFilter="true"
                  :provider="selectedProvider"
                  :reps="salesRep"
                  :selectedReps="getUserById(filters.reps)"
                  :productFilter="true"
                  :selectedProduct="this.filters.product"
                  @applyFilter="handleFilter">
    </reportFilter>
    <WatingDialog :visible="loading || toggleLoading" content="Veuillez patienter pendant que nous préparons votre rapport. Cela peut prendre plusieurs secondes."></WatingDialog>
    <el-button 
      v-if="showScrollTop" 
      @click="scrollToTop" 
      class="scroll-to-top-btn"
      type="primary" 
      icon="el-icon-arrow-up" 
      circle>
    </el-button>
</div>
<!-- </el-row> -->
</el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import systemAPI from '@/services/API/system.js'
import moment from 'moment'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
// import { extendMoment } from 'moment-range';
// const moment = extendMoment(Moment);
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import * as echarts from 'echarts';
import Promise from "bluebird";
import WatingDialog from '@/components/waiting-dialog'

export default {
  name : "Sales-report",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      data : [],
      loading: true,
      filters : {
        range : 'MONTH',
        startDate : null,
        endDate : null,
        statuses : [],
        customerId : null,
        providerId: null,
        groupBy : 'CUSTOMER',
        reps : [],
        customer_classes : [],
        products : [],
      },
      reportFilterVisible : false,
      showZeroTotalCases: false,
      appliedShowZeroTotalCases: false,
      toggleLoading: false,
      showVariance: true,
      showScrollTop: false,
      scrollHandler: null,
    };
  },
  components : {
    reportFilter,
    WatingDialog
  },
  watch: {
    showVariance(newVal) {
      localStorage.sales_showVariance = newVal;
    }
  },
  computed : {
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      const endDate = moment();
      const startDate = moment().subtract(11, 'months');
      return `${startDate.format('MMMM YYYY')} - ${endDate.format('MMMM YYYY')}`;
    },
    reportCode(){
      return this.$route.params.code;
    },
    filteredTableData() {
      if (!Array.isArray(this.data)) return [];
      if (this.appliedShowZeroTotalCases) return this.data;
      return this.data.filter(row => this.getTotalCases(row) > 0);
    },
    monthColumns() {
      return _.range(11, -1, -1).map((i) => ({
        prop: `m_${i}`,
        monthIndex: i,
        label: moment().subtract(i, 'months').format('MMM YY'),
      }));
    },
    salesRep(){
      return this.filterUserWithRoleRep;
    },
    ...mapState('inventory',['inventories']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),
    ...mapState('controlData',['customerClasses']),
    ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'getCurrentUserId', 'isCurrentUserAdmin']),

  },
  methods : {
    handleFilter(filters){
      localStorage.sales_range = filters.period != null ? filters.period.code : 'MONTH';

      if (filters.period != null && filters.period.code === 'CUSTOM' && filters.dateRange != null && filters.dateRange.length === 2) {
        localStorage.sales_startDate = filters.dateRange[0];
        localStorage.sales_endDate = filters.dateRange[1];
      }

      let inventories = [];
      _.forEach(filters.inventories, m=>{
        inventories.push(m.id);
      })
      localStorage.sales_inventories = JSON.stringify(inventories);
      
      localStorage.sales_customerId = filters.customer!=null ? filters.customer.id : undefined;
      localStorage.sales_providerId = filters.provider!=null ? filters.provider.id : undefined;
      let reps = [];
      _.forEach(filters.reps, m=>{
        reps.push(m.id);
      })
      localStorage.sales_reps = JSON.stringify(reps);

      localStorage.sales_product = JSON.stringify(filters.product);

      let customer_classes = [];
      _.forEach(filters.customer_classes, m=>{
        customer_classes.push(m.id);
      })
      localStorage.sales_customer_classes = JSON.stringify(customer_classes);

      this.setFilters();
      this.fetchData();
    },
    formatMonthValue(row, column, cellValue) {
      return cellValue || '';
    },
    getTotalCases(row) {
      if (!row) return 0;
      const total = _.range(0, 12).reduce((sum, i) => sum + (Number(row[`m_${i}`]) || 0), 0);
      return Math.round(total * 100) / 100;
    },
    sortByTotalCases(a, b) {
      return this.getTotalCases(a) - this.getTotalCases(b);
    },
    getVariance(row) {
      if (!row) return null;
      const currentTotal = _.range(0, 12).reduce((sum, i) => {
        return sum + (Number.parseFloat(row[`m_${i}`]) || 0);
      }, 0);
      const lastYearTotal = _.range(12, 24).reduce((sum, i) => {
        return sum + (Number.parseFloat(row[`m_${i}`]) || 0);
      }, 0);
      if (lastYearTotal === 0) return null;
      return ((currentTotal - lastYearTotal) / lastYearTotal) * 100;
    },
    getVarianceClass(row) {
      const variance = this.getVariance(row);
      if (variance === null) return 'variance-neutral';
      if (variance > 0) return 'variance-positive';
      if (variance < 0) return 'variance-negative';
      return 'variance-neutral';
    },
    getVarianceText(row) {
      const variance = this.getVariance(row);
      if (variance === null) return '-';
      const sign = variance > 0 ? '+' : '';
      return `${sign}${Math.round(variance)}%`;
    },
    getMonthVariance(row, monthIndex) {
      if (!row) return null;
      const current = Number.parseFloat(row[`m_${monthIndex}`]) || 0;
      const lastYear = Number.parseFloat(row[`m_${monthIndex + 12}`]) || 0;
      if (lastYear === 0) return null;
      return ((current - lastYear) / lastYear) * 100;
    },
    getMonthVarianceClass(row, monthIndex) {
      const variance = this.getMonthVariance(row, monthIndex);
      if (variance === null) return 'variance-neutral';
      if (variance > 0) return 'variance-positive';
      if (variance < 0) return 'variance-negative';
      return 'variance-neutral';
    },
    getMonthVarianceText(row, monthIndex) {
      const variance = this.getMonthVariance(row, monthIndex);
      if (variance === null) return '-';
      const sign = variance > 0 ? '+' : '';
      return `${sign}${Math.round(variance)}%`;
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    handleToggleZeroTotalCases() {
      this.toggleLoading = true;
    },
    handleZeroTotalCasesChange(value) {
      setTimeout(() => {
        this.appliedShowZeroTotalCases = value;
        localStorage.sales_showZeroTotalCases = value;
        this.toggleLoading = false;
      }, 250);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    downloadExcel() {
      const rows = this.filteredTableData.map((row) => {
        const r = {
          'Produit': row.product_name,
          'SKU': row.sku,
          'Format': row.format,
          'Volume': row.volume,
        };
        this.monthColumns.forEach((col) => {
          r[col.label] = this.formatMonthValue(row, null, row[col.prop]);
          if (this.showVariance) {
            r[col.label + ' var.'] = this.getMonthVarianceText(row, col.monthIndex);
          }
        });
        r['Total caisses'] = this.getTotalCases(row);
        if (this.showVariance) {
          r['Total var.'] = this.getVarianceText(row);
        }
        return r;
      });

      // Ligne de totaux
      const totalsRow = { 'Produit': 'TOTAL', 'SKU': '', 'Format': '', 'Volume': '' };
      this.monthColumns.forEach((col) => {
        totalsRow[col.label] = _.sumBy(rows, (r) => Number(r[col.label]) || 0);
        if (this.showVariance) {
          totalsRow[col.label + ' var.'] = '';
        }
      });
      totalsRow['Total caisses'] = _.sumBy(rows, (r) => Number(r['Total caisses']) || 0);
      if (this.showVariance) {
        totalsRow['Total var.'] = '';
      }
      rows.push(totalsRow);

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Ventes par produit');
      const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
      const filename = `ventes-par-produit-${moment().format('YYYY-MM-DD')}.xlsx`;
      saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), filename);
    },
    prepareBuildRequest () {
      let filters = _.cloneDeep(this.filters);

      filters.productId = filters.product != null ? filters.product.id : undefined;
      delete filters.product;
      return filters;
    },
    fetchData(){
      this.loading = true;
      
      let filters = this.prepareBuildRequest();

      return salesAPI.getSummarySalesByProduct(filters)
        .then(data=>{
          this.data = data;
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){

      if(localStorage.sales_range==null){
        localStorage.sales_range='MONTH';
      }

 
      this.filters.customerId=localStorage.sales_customerId!='undefined' && localStorage.sales_customerId!=null  ? parseInt(localStorage.sales_customerId) : undefined;
      this.filters.providerId=localStorage.sales_providerId!='undefined' && localStorage.sales_providerId!=null  ? parseInt(localStorage.sales_providerId) : undefined;

      this.filters.reps=localStorage.sales_reps!=null ? JSON.parse(localStorage.sales_reps) : [];

      this.filters.product = localStorage.sales_product !=null ? JSON.parse(localStorage.sales_product) : null;

      this.filters.customer_classes=localStorage.sales_customer_classes!=null ? JSON.parse(localStorage.sales_customer_classes) : [];
      this.filters.inventories=localStorage.sales_inventories!=null ? JSON.parse(localStorage.sales_inventories) : [];

      this.applyStrictRepFilter();

      // Charger les préférences d'affichage
      this.appliedShowZeroTotalCases = localStorage.sales_showZeroTotalCases === 'true';
      this.showZeroTotalCases = this.appliedShowZeroTotalCases;
      this.showVariance = localStorage.sales_showVariance !== 'false';
    },
    applyStrictRepFilter() {
      if (this.isStrictFilteredByRep === true && this.isCurrentUserRep === true && !this.isCurrentUserAdmin && this.getCurrentUserId != null) {
        this.filters.reps = [this.getCurrentUserId];
        localStorage.sales_reps = JSON.stringify(this.filters.reps);
      }
    },
    ...mapActions('inventory',['fetchInventories']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('controlData',['fetchCustomerClasses'])
  },
  mounted(){
    this.scrollHandler = () => this.handleScroll();
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy(){
    this.data = [];
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  },
  created(){
    this.loading = true;
    return Promise.all([
      this.fetchAdminUsers(),
      this.fetchInventories(),
      this.fetchCustomerClasses()])
        .then(()=> this.setFilters())
        .then(() => this.fetchData())
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;
  display:flex;
  align-items:center;
  gap:8px;

	button{
		margin-left:20px;
	}
}

.toggle-zero-label {
  font-size: 12px;
}

::v-deep .fs-10 .el-table__cell {
  padding: 2px 0;
}

.product-name,
.product-sku {
  line-height: 1.5;
  margin: 0;
}

.product-meta {
  line-height: 1.5;
  margin: 0;
  color: #606266;
}

.month-value-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.month-value {
  font-size: 12px;
  font-weight: 500;
}

.total-cases-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.total-value {
  font-weight: bold;
  font-size: 14px;
}

.variance {
  font-size: 11px;
  font-weight: 500;
}

.variance-positive {
  color: #67c23a;
}

.variance-negative {
  color: #f56c6c;
}

.variance-neutral {
  color: #909399;
}

::v-deep .scroll-to-top-btn {
  position: fixed !important;
  bottom: 30px !important;
  right: 30px !important;
  z-index: 1000 !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15) !important;
}


</style>
